import React from 'react';
import { formatCurrency } from 'utils';
import { Listing, ListingEvent, Pagination } from 'components/shared/TableListing';
import { Box, Stack, Typography } from '@mui/material';
import { blue, grey } from '@mui/material/colors';

import { ReportsListingViewModel } from '../../types';
import { getReportsListingConfig } from './reportsListingConfig';

interface Props {
  loading: boolean;
  pagination: Pagination;
  onFetchGroupItems: (group: string) => void;
  groupsPagination: Record<string, Pagination>;
  groupsState: Record<string, { data: ReportsListingViewModel[]; loading: boolean }>;
  groups: { key: string; name: string; voCount: number; invoiceSum: number }[];
}

export const ReportsListing = ({
  loading,
  groups,
  pagination,
  groupsState,
  groupsPagination,
  onFetchGroupItems,
}: Props) => {
  const columns = getReportsListingConfig();

  const onListingSubscribe = (event: ListingEvent, group: unknown) => {
    if (typeof group === 'string' && event === 'groupOpened') {
      onFetchGroupItems(group);
    }
  };

  return (
    <Listing<ReportsListingViewModel>
      tableData={[]}
      loading={loading}
      columns={columns}
      pagination={pagination}
      onEmit={onListingSubscribe}
      groups={groups.map(group => ({
        name: group.key,
        data: groupsState[group.key]?.data ?? [],
        pagination: groupsPagination[group.key],
        isLoading: !!groupsState[group.key]?.loading,
        beforeGroup: {
          render: () => (
            <Stack direction="row" gap="0.5rem" alignItems="center">
              <Typography>{group.name}</Typography>

              <Box
                sx={{
                  display: 'flex',
                  width: '1.5rem',
                  height: '1.5rem',
                  alignItems: 'center',
                  borderRadius: '100%',
                  justifyContent: 'center',
                  backgroundColor: grey[300],
                }}
              >
                <Typography>{group.voCount}</Typography>
              </Box>
            </Stack>
          ),
          cellStyles: {
            backgroundColor: grey[50],
          },
        },
        afterGroup: {
          render: () => (
            <Stack direction="row" gap="0.5rem">
              <Typography>Subtotal</Typography>
              <Typography>{formatCurrency(group.invoiceSum, true)}</Typography>
            </Stack>
          ),
          cellStyles: {
            backgroundColor: blue[100],
          },
        },
      }))}
    />
  );
};
